// @flow

export class BaseFormData<T> {
  values: { [T]: ?string }

  constructor() {
    this.values = {}
  }

  value(fieldName: T): string {
    return this.values[fieldName] || ''
  }

  update(fieldName: T, value: string): BaseFormData<T> {
    // make sure we don't get an issue because we update the original object
    this.values[fieldName] = value

    // $FlowFixMe[incompatible-return]
    return Object.assign(Object.create(Object.getPrototypeOf(this)), this)
  }
}
